import React from 'react'

interface Properties {
    title: string
    dates: string
    company: string
    location?: string
    children?: React.ReactNode
}

export default function Entry({title, dates, company, location, children}: Properties) {
    return (
        <div className="print-avoid-break font-body text-neutral-700">
            <div>
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                    <h3 className="font-display font-semibold text-lg text-neutral-800">{title}</h3>
                    <span className="font-body text-sm text-neutral-500 whitespace-nowrap">{dates}</span>
                </div>
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                    <span className="font-display font-medium text-primary">{company}</span>
                    {location && <span className="font-body text-sm text-neutral-500">{location}</span>}
                </div>
            </div>
            {children && (
                <div className="text-sm leading-relaxed mt-2">
                    {children}
                </div>
            )}
        </div>
    )
}
